<template>
  <div class="product-details-content-register-submodule-basic">
    <snow-input
      v-model="form.name"
      id="name"
      label="Nome do submódulo"
      :errors="errors.name"
      :maxLength="240"
      required
    />
    <action-dispatcher
      action="membersModules/get"
      :parameters="{
        product_id: $route.params.id,
        limit: 1000
      }"
    >
      <snow-select
        v-model="form.parent"
        :errors="errors.parent"
        id="parent"
        label="Módulo"
        class="mb-2"
        :options="modulesOptions"
      />
      <h5 class="text-dark-40">
        Módulo ao qual pertence o submódulo.
      </h5>
    </action-dispatcher>

    <div class="pt-4">
      <h5 class="text-semibold">
        Liberação do submódulo
      </h5>
      <h6 class="text-dark-40">
        Determine em quantos dias o seu conteúdo será liberado após a compra.
      </h6>
    </div>

    <snow-switch
      id="_days_to_release"
      v-model="days_to_release"
      label="Liberar após quantidade de dias"
    />

    <div v-if="days_to_release">
      <snow-input
        v-model="form.days_to_release"
        :errors="errors.days_to_release"
        id="days_to_release"
        label="Liberar após"
        mask="###"
      />
    </div>

    <snow-switch
      id="_release_at"
      v-model="release_at"
      label="Liberar em uma data específica"
    />

    <div v-if="release_at">
      <!-- <form-group
        v-model="form.release_at"
        :errors="errors.release_at"
        id="release_at"
        placeholder="00/00/0000"
        label="Liberar no dia"
        is-date
      /> -->
      <snow-date-picker
        v-model="form.release_at"
        id="release_at"
        size="lg"
        single
        label="Liberar no dia"
      />
    </div>
  </div>
</template>
<script>
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    module: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      days_to_release: !!this.form.days_to_release,
      release_at: !!this.form.release_at
    };
  },
  computed: {
    ...mapState("membersModules", ["modules"]),
    modulesOptions() {
      return [{ id: null, name: "Nenhum" }, ...this.modules];
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(v) {
        this.days_to_release = !!v.days_to_release;
        this.release_at = !!v.release_at;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.product-details-content-register-submodule-basic {
  display: flex;
  flex-direction: column;
  gap: 16px;
  .subtitle {
    color: #3b3b4ae6;
    font-size: 16px;
    font-weight: 400;
  }
  .description {
    color: #77788ede;
    font-size: 13px;
  }
  .button {
    color: #3b3b4ae6;
    font-size: 15px;
    font-weight: 400;
  }
}
</style>
